import HeaderBilingualLabel from "@/components/HeaderBilingualLabel";

export default function HeaderTextLink({
  en,
  ko,
  href,
  to,
  onClick,
  className = "",
  testId,
  as: Tag = "a",
  ...rest
}) {
  const linkProps =
    Tag !== "a" && to != null
      ? { to }
      : href != null
        ? { href }
        : {};

  return (
    <Tag
      {...linkProps}
      data-testid={testId}
      className={`ds-header-text-link ${className}`.trim()}
      aria-label={ko}
      onClick={onClick}
      {...rest}
    >
      <HeaderBilingualLabel en={en} ko={ko} />
    </Tag>
  );
}
